import { render, staticRenderFns } from "./fulfillment-detail-settings.vue?vue&type=template&id=1cd1b5f8"
import script from "./fulfillment-detail-settings.vue?vue&type=script&lang=js"
export * from "./fulfillment-detail-settings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports